<main
    *ngIf="distribution"
    class="agpr-container"
    [agprLoading]="loading"
    #overlayContainer
>

    <section
        class="agpr-center"
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <h2>
            <div *ngIf="distribution?.name" class="agpr-distribution-name">{{ distribution?.name }}&nbsp;</div>
            <span class="u-srOnly">{{ 'Discover.pageHeader.distribution' | localize }}</span>
        </h2>
        <agpr-distribution-steps-navigation
            class="agpr-distribution-stepsNavigation"
            [selectedTabIndex]="currentStep"
            [allErrors]="bannerErrorList"
            (selectedTabIndexChange)="changeStep($event)"
        >
            <agpr-tab
                #composeTab
                [id]="distributionStepIds.compose"
                heading="Discover.distribution.stepsNavigation.compose"
            >
                <div
                    class="agpr-center-blocks"
                    [style.max-width]="maxWidthEnabled ? (distributionMaxWidthPx + 40) + 'px' : 'unset'"
                >
                    <agpr-scroll-panel #contentScroll
                        class="agpr-center-scrollpanel"
                    >
                        <div class="agpr-center-container">
                            <agpr-distribution-header
                                class="agpr-distribution-header"
                                ariaDescribedBy="header_errors"
                                (clicked)="openHeaderEditor()"
                            ></agpr-distribution-header>
                            <ul
                                id="header_errors"
                                *ngIf="errors.headerHasNoSubjectLine || errors.headerHasNoFrom || errors.headerHasInvalidEmail || errors.headerHasNoReplyTo"
                            >
                                <li *ngIf="errors.headerHasNoSubjectLine">
                                    <agpr-form-message>
                                        {{ 'Discover.targeting.distribution.header.errors.hasNoSubjectLine' | localize }}
                                    </agpr-form-message>
                                </li>
                                <li *ngIf="errors.headerHasNoFrom">
                                    <agpr-form-message>
                                        {{ 'Discover.targeting.distribution.header.errors.hasNoFrom' | localize }}
                                    </agpr-form-message>
                                </li>
                                <li *ngIf="errors.headerHasInvalidEmail">
                                    <agpr-form-message>
                                        {{ 'invalidEmailFormat' | localize }}
                                    </agpr-form-message>
                                </li>
                                <li *ngIf="errors.headerHasNoReplyTo">
                                    <agpr-form-message>
                                        {{ 'Discover.targeting.distribution.header.errors.hasNoReplyEmail' | localize }}
                                    </agpr-form-message>
                                </li>
                            </ul>
                            <agpr-distribution-view-in-browser
                                [text]="distribution.viewInBrowserLinkText"
                                [show]="distribution.includeViewInBrowserLink"
                            >
                            </agpr-distribution-view-in-browser>
                            <agpr-page-builder
                                (blockAdded)="scrollToAddedBlock($event)"
                                [inlineAdderAdjustment]="true"
                                actionMenuTextAlignment="left"
                            ></agpr-page-builder>
                            <agpr-form-message
                                id="footerErrors_mergeTags"
                                *ngIf="errors.footerMissingMergeTags"
                            >
                                <div class="missingTags">
                                    <span class="missingTags-header">{{ 'Discover.targeting.distribution.footer.errors.header' | localize }}</span>
                                    <span
                                        class="missingTags-content"
                                        [innerHtml]="'Discover.targeting.distribution.footer.errors.message' | localize: {tags: errors.missingTags | listTooltip}"
                                    >
                                    </span>
                                </div>
                            </agpr-form-message>

                        </div>
                    </agpr-scroll-panel>
                </div>
            </agpr-tab>
            <agpr-tab
                #editRecipientsTab
                noScrollPanelContent
                [id]="distributionStepIds.editRecipients"
                heading="Discover.distribution.stepsNavigation.editRecipients"
                [ngClass]="{ 'agpr-distribution-recipientsTab': editRecipientsTab?.selected }"

            >
                <agpr-distribution-recipient
                    class="agpr-distribution-recipientTab"
                    *ngIf="editRecipientsTab?.selected"
                ></agpr-distribution-recipient>
            </agpr-tab>
            <agpr-tab
                #personalizeTab
                noScrollPanelContent
                [id]="distributionStepIds.personalize"
                heading="Discover.distribution.personalize"
                [ngClass]="{ 'agpr-distribution-personalizeTab': personalizeTab?.selected }"
            >
                <agpr-personalize
                    *ngIf="personalizeTab?.selected"
                    (moveToRecipientStep)="selectRecipientTab()"
                    (saveDistribution)="saveDistribution()"
                    (hidePersonalizeSideBar)="hidePersonalizeSidebar = $event"
                ></agpr-personalize>
            </agpr-tab>
            <agpr-tab
                #reviewTab
                [id]="distributionStepIds.review"
                heading="Discover.distribution.stepsNavigation.review"
            >
                <agpr-distribution-review
                    [compositionErrors]="compositionErrors"
                    [attachments]="attachments"
                    (changeStep)="currentStep = $event"
                ></agpr-distribution-review>
            </agpr-tab>
        </agpr-distribution-steps-navigation>
        <agpr-action-bar
            id="agpr_distribution_action_bar"
            [headingContext]="'Discover.distribution.distribution' | localize"
        >
            <ng-template #left>
                <agpr-button
                    *ngIf="!composeTab.selected"
                    [label]="'Discover.distribution.backToPreviousStep'"
                    [style]="buttonTypes.secondary"
                    (click)="currentStep = currentStep - 1"
                ></agpr-button>
            </ng-template>
            <ng-template #right>
                @if (distribution.id && !distributionDirty) {
                    <agpr-button
                        id="distribution.SaveTemplateButton'"
                        label="Discover.targeting.distribution.rhp.saveAsTemplate"
                        [style]="buttonTypes.primaryB"
                        (click)="saveAsTemplate()"
                    ></agpr-button>
                }
                <agpr-button
                    *ngIf="distributionDirty || removedIndividualGroup"
                    [label]="distribution?.id ? 'Discover.targeting.actions.saveDistributionChanges' : 'Discover.targeting.actions.saveDistribution'"
                    [loading]="savePending"
                    [style]="buttonTypes.primaryB"
                    (click)="saveDistribution()"
                ></agpr-button>
                <agpr-button
                    *ngIf="distributionSchedulable && reviewTab.selected"
                    [label]="'Discover.targeting.actions.sendDistribution'"
                    [style]="buttonTypes.primary"
                    (click)="send()"
                ></agpr-button>
                <agpr-button
                    *ngIf="!reviewTab.selected"
                    [label]="'Discover.distribution.nextStep'"
                    [style]="buttonTypes.primary"
                    (click)="currentStep = currentStep + 1"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </section>

    <aside
        class="agpr-sidebar"
        [ngClass]="{'personalizeSideBar': personalizeTab?.selected}"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-right-sidebar
            *ngIf="!editRecipientsTab?.selected && !personalizeTab?.selected"
            [(selectedTabIndex)]="selectedRhpTabIndex"
            #rightSidebar
        >
            <ng-template #footer>
                <agpr-action-bar
                    [headingContext]="'Discover.targeting.distribution.rhp.footerContext' | localize"
                    [headingLevel]="4"
                >
                    <ng-template
                        *ngIf="selectedBlock && selectedRhpTabIndex === blockFormTabIndex"
                        #right
                    >
                        <agpr-button
                            label="Discover.apply"
                            id="distribution.applyChangesButton"
                            [style]="buttonTypes.tertiary"
                            (click)="distributionService.confirmChangesToSelectedBlock()"
                        ></agpr-button>
                        <agpr-button
                            *ngIf="isDefaultFooterDirty && selectedBlock?.type.key === distributionBlockType.footer"
                            label="Discover.distribution.footer.settings.setAsDefault"
                            id="distribution.setAsDefault"
                            [style]="buttonTypes.tertiary"
                            tooltip="Discover.distribution.footer.settings.setAsDefault.tooltip"
                            tooltipPosition="top"
                            (click)="distributionService.setDefaultFooter()"
                        ></agpr-button>
                    </ng-template>

                </agpr-action-bar>
                <ng-container *ngTemplateOutlet="onlineBoost"></ng-container>
            </ng-template>
            <!-- Distribution Settings -->
            <agpr-tab
                icon=" fa-sliders"
                tooltip="Discover.distribution.settings"
                [id]="'distribution_settingsTab'"
            >
                <ng-container *ngIf="composeTab.selected">
                    <agpr-panel
                        [id]="'distribution_componentsPanel'"
                        header="Discover.distribution.headingComponents"
                        [paddingBottom]="0"
                    >
                        <agpr-block-adder
                            [id]="'distributions_blockAdder'"
                            [draggable]="true"
                        ></agpr-block-adder>
                    </agpr-panel>
                    <agpr-panel
                        [id]="'distribution_layoutPanel'"
                        header="Discover.distribution.headingLayout"
                        [paddingBottom]="0"
                    >
                        <agpr-layout-block-adder
                            [id]="'distributions_layoutBlockAdder'"
                            [draggable]="true"
                        ></agpr-layout-block-adder>
                    </agpr-panel>
                    <agpr-panel>
                        <agpr-file-upload #fileUpload
                            id="distribution.attachments"
                            header="Discover.distribution.attachments"
                            [headerTooltip]="'Discover.distribution.attachments.tooltip'"
                            [panelToggleable]="true"
                            [maxFileSize]="5242880"
                            [maxFileSizeCombined]="5242880"
                            uploadButtonLabel=""
                            [useContentLibraryUpload]="true"
                            [uploadButtonIcon]="'fa-regular fa-duotone fa-square-plus'"
                            [holdFileData]="true"
                            [(ngModel)]="attachments"
                            (ngModelChange)="attachmentChange($event)"
                            (uploadButtonClick)="openContentLibrary()"
                            (onRemove)="removeAttachment($event)"
                            [uppercaseHeader]="false"
                            [showThumbnail]="true"
                            [maxFiles]="maxNumberOfAttachments"
                            [showPanelSubHeader]="true"
                            [showPanelCustomHeader]="false"

                        ></agpr-file-upload>
                        @if (hasDuplicateAttachments) {
                            <agpr-form-message id="distribution.attachments_error">
                                {{ 'Discover.distribution.attachmentDuplicate.message' | localize }}
                            </agpr-form-message>
                    }
                    </agpr-panel>
                    <agpr-panel [id]="'distribution_otherSettingsPanel'" header="Briefings.sidebar.headingOtherSettings">
                        <div class="agpr-briefing-sidebar-otherSettingsCheckbox">
                            <agpr-checkbox
                                id="distribution_otherSettings_viewInBrowser"
                                label="Discover.distribution.otherSettings.viewInBrowser"
                                infoCircleTooltip="Discover.distribution.otherSettings.viewInBrowser.tooltip"
                                [binary]="true"
                                [(ngModel)]="distribution.includeViewInBrowserLink"
                                (onChange)="distributionService.updateDirtyFlag()"
                            ></agpr-checkbox>
                            <div *ngIf="distribution.includeViewInBrowserLink" class="agpr-distribution-rhp-margin-top padding-left">
                                <agpr-text-input
                                    [maxLength]="255"
                                    [label]="'Discover.distribution.otherSettings.viewInBrowser.linkText'"
                                    [id]="'distribution.otherSettings.viewInBrowser.linkText'"
                                    value='Discover.distribution.otherSettings.viewInBrowser.linkText'
                                    [(ngModel)]="distribution.viewInBrowserLinkText"
                                    (ngModelChange)="distributionService.updateDirtyFlag()"
                                ></agpr-text-input>
                            </div>
                            @if (dataConnectionService.hasEmailAccountProvision$ | async) {
                                <agpr-checkbox
                                    id="distribution_otherSettings_includeFooter"
                                    label="Discover.distribution.otherSettings.includeFooter"
                                    infoCircleTooltip="Discover.distribution.otherSettings.includeFooter.tooltip"
                                    [binary]="true"
                                    [disabled]="!distribution.sendFrom"
                                    [(ngModel)]="distribution.includeFooter"
                                    (onChange)="includeFooterChanged()"
                                ></agpr-checkbox>
                            }
                            <agpr-message
                                id="distribution_otherSettings_tipsBanner"
                                class="agpr-distribution-tipsBanner"
                                [severity]="messageSeverityEnum.info"
                                [bottomMargin]="false"
                            >
                                <span [innerHTML]="'Discover.targeting.distribution.tipsBanner' | localize"></span>
                            </agpr-message>
                        </div>
                    </agpr-panel>
                </ng-container>
                <ng-container *ngIf="reviewTab.selected">
                    <agpr-panel
                        [id]="'distribution_confirmationRecipientsPanel'"
                        header="Discover.distribution.confirmationRecipients"
                        tooltip="Discover.distribution.confirmationRecipients.tooltip"
                    >
                        <agpr-email-chips
                            [id]="'confirmationRecipients.chips'"
                            [(value)]="distribution.confirmationRecipients"
                            (valueChange)="distributionService.updateDirtyFlag()"
                            [placeholder]="'Discover.distribution.confirmationRecipients.placeholder'"
                            [errorKey]="'Discover.targeting.distribution.editRecipient.invalidEmailMessage' | localize"
                            [showDuplicateErrorKey]="'Common.forms.email.duplicateEmail'"
                        ></agpr-email-chips>
                    </agpr-panel>
                    <agpr-panel
                        [id]="'distribution_scheduling_panel'"
                        header="Briefings.sidebar.headingScheduling"
                    >
                        <agpr-delivery-schedule-input
                            id="distribution-deliveryScheduler"
                            [ngModel]="distribution.deliverySchedule"
                            (ngModelChange)="deliveryScheduleChanged($event)"
                            [immediateOptionLabel]="'Briefings.input.publishNow'"
                            [futureOptionLabel]="'Briefings.input.publishLater'"
                            [showRecurring]="false"
                            [minDateValidationMessage]="'Briefings.error.minDateTooEarly'"
                        ></agpr-delivery-schedule-input>
                    </agpr-panel>
                    <agpr-panel
                        [id]="'distribution_trackingPanel'"
                        header="Discover.distribution.tracking.heading"
                        [marginTop]="0"
                    >
                        <agpr-checkbox
                            id="distribution_otherSettings_clickTracking"
                            label="Discover.distribution.otherSettings.clickTracking.label"
                            class="agpr-distribution-tracking-checkbox"
                            infoCircleTooltip="Discover.distribution.otherSettings.clickTracking.tooltip"
                            [(ngModel)]="distribution.clickTracking"
                            [binary]="true"
                            (onChange)="distributionService.updateDirtyFlag()"
                        ></agpr-checkbox>
                        <agpr-checkbox
                            id="distribution_otherSettings_openTracking"
                            label="Discover.distribution.otherSettings.openTracking.label"
                            infoCircleTooltip="Discover.distribution.otherSettings.openTracking.tooltip"
                            [(ngModel)]="distribution.openTracking"
                            [binary]="true"
                            (onChange)="distributionService.updateDirtyFlag()"
                        ></agpr-checkbox>
                    </agpr-panel>
                </ng-container>
            </agpr-tab>

            <!-- Content Validation -->
            <agpr-tab
                icon=" fa-file-check"
                tooltip="Discover.distribution.contentValidation"
                [id]="'distribution_contentValidationTab'"
            >
                <agpr-panel
                    [id]="'distribution_devicePreviewPanel'"
                    header="Discover.distribution.preview.device"
                    tooltip="Discover.distribution.preview.device.tooltip"
                >
                    <div class="agpr-devicePreview-button-alignmentButtons agpr-devicePreview-button" role="radiogroup">
                        <agpr-radio
                            id="devicePreview.buttons.desktop"
                            name="device_select"
                            [value]="screenTypes.desktop"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-desktop'"
                            [iconTooltip]="'Discover.distribution.preview.desktop.tooltip' | localize"
                            tooltipPosition="right"
                            [(ngModel)]="selectedScreenType"
                            (onClick)="openDevicePreview(screenTypes.desktop)"
                        ></agpr-radio>
                        <agpr-radio
                            id="devicePreview.buttons.tabletPortrait"
                            name="device_select"
                            [value]="screenTypes.tabletPortrait"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-tablet-screen-button'"
                            [iconTooltip]="'Discover.distribution.preview.tabletPortrait.tooltip' | localize"
                            tooltipPosition="right"
                            [(ngModel)]="selectedScreenType"
                            (onClick)="openDevicePreview(screenTypes.tabletPortrait)"
                        ></agpr-radio>
                        <agpr-radio
                            id="devicePreview.buttons.tabletLandscape"
                            name="device_select"
                            [value]="screenTypes.tabletLandscape"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-tablet-screen-button landscape'"
                            [iconTooltip]="'Discover.distribution.preview.tabletLandscape.tooltip' | localize"
                            tooltipPosition="right"
                            [(ngModel)]="selectedScreenType"
                            (onClick)="openDevicePreview(screenTypes.tabletLandscape)"
                        ></agpr-radio>
                        <agpr-radio
                            id="devicePreview.buttons.mobilePortrait"
                            name="device_select"
                            [value]="screenTypes.mobilePortrait"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-mobile-screen-button'"
                            [iconTooltip]="'Discover.distribution.preview.mobilePortrait.tooltip' | localize"
                            tooltipPosition="right"
                            [(ngModel)]="selectedScreenType"
                            (onClick)="openDevicePreview(screenTypes.mobilePortrait)"
                        ></agpr-radio>
                        <agpr-radio
                            id="devicePreview.buttons.mobileLandscape"
                            name="device_select"
                            [value]="screenTypes.mobileLandscape"
                            [style]="radioTypesEnum.button"
                            [icon]="'fa-mobile-screen-button landscape'"
                            [iconTooltip]="'Discover.distribution.preview.mobileLandscape.tooltip' | localize"
                            tooltipPosition="right"
                            [(ngModel)]="selectedScreenType"
                            (onClick)="openDevicePreview(screenTypes.mobileLandscape)"
                        ></agpr-radio>
                    </div>
                </agpr-panel>
                <agpr-panel
                    [id]="'distribution_testEmailPanel'"
                    header="Discover.distribution.preview.email"
                    tooltip="Discover.distribution.preview.email.tooltip"
                    class="agpr-testEmail"
                >
                    <div class="padding-left">
                        <label>
                            {{ 'Discover.distribution.preview.email.addresses' | localize }}
                        </label>
                        <span
                            role="img"
                            class="agpr-testEmail-infoCircle fa-regular fa-circle-info"
                            agprTooltip="Discover.distribution.preview.email.addresses.placeholder"
                        ></span>
                    </div>
                    <div class="agpr-testEmail-chips padding-left">
                        <agpr-email-chips
                            [id]="'distribution.testEmail.recipientChips'"
                            [(value)]="testEmailRecipients"
                            [disabled]="justSentTest"
                            [placeholder]="'Briefings.input.recipients.placeholder' | localize"
                            [errorKey]="'invalidEmailFormat' | localize"
                        ></agpr-email-chips>
                    </div>
                    <agpr-button
                        *ngIf="!justSentTest"
                        class="agpr-testEmail-button"
                        id="distribution.testEmail.sendButton"
                        [style]="buttonTypes.tertiary"
                        [disabled]="testEmailRecipients?.length === 0"
                        label="Discover.distribution.preview.email.addresses.send"
                        (click)="sendTestEmail()"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="justSentTest"
                        class="agpr-testEmail-button"
                        id="distribution.testEmail.sendButton"
                        [style]="buttonTypes.tertiary"
                        label="Discover.distribution.preview.email.addresses.sendAnother"
                        (click)="justSentTest = false"
                    ></agpr-button>
                </agpr-panel>
                <agpr-panel
                    *ngIf="composeTab.selected"
                    [id]="'distribution_plainTextEditorPanel'"
                    header="Discover.distribution.plainTextEditor.panel.header"
                    tooltip="Discover.distribution.plainTextEditor.panel.tooltip"
                    class="agpr-plainTextEditor"
                >
                    <agpr-button
                        id="plainTextEditor.openDialogButton"
                        label="Discover.distribution.plainTextEditor.panel.button"
                        [style]="buttonTypes.tertiary"
                        (click)="openPlainTextEditor()"
                    ></agpr-button>
                    <agpr-message
                        id="distribution_plainTextEditor_tipsBanner"
                        class="agpr-distribution-tipsBanner"
                        [severity]="messageSeverityEnum.info"
                        [bottomMargin]="false"
                    >
                        <span [innerHTML]="'Discover.targeting.distribution.tipsBanner' | localize"></span>
                    </agpr-message>
                </agpr-panel>
            </agpr-tab>
            <!-- Section Settings -->
            <agpr-tab
                #blockFormTab
                *ngIf="composeTab.selected"
                icon=" fa-wrench"
                tooltip="Briefings.rhp.blockEdit"
                [disabled]="!selectedBlock"
                [id]="'distributionComponentblockFormTab'"
            >
                <agpr-block-form></agpr-block-form>
            </agpr-tab>
            <!-- Distribution Customization -->
            <agpr-tab
                *ngIf="composeTab.selected"
                [id]="'distributionComponentCustomizeTab'"
                icon=" fa-paintbrush"
                tooltip="Discover.targeting.distribution.rhp.generalStylesTooltip"
                [disabled]="distribution.status !== distributionStatuses.draft"
            >
                <agpr-panel
                    [id]="'distribution_formatPanel'"
                    class="agpr-distributionMaxWidth"
                    header="Discover.targeting.distribution.rhp.formatHeader"
                    [paddingBottom]="0"
                >
                    <agpr-checkbox
                        id="distributionMaxWidth_checkbox"
                        label="Discover.targeting.distribution.rhp.maxWidth.checkboxLabel"
                        infoCircleTooltip="Discover.targeting.distribution.rhp.maxWidth.tooltip"
                        [binary]="true"
                        [(ngModel)]="maxWidthEnabled"
                        (ngModelChange)="enableMaxWidth()"
                    ></agpr-checkbox>
                    <agpr-number-input
                        *ngIf="maxWidthEnabled"
                        [integerOnly]="true"
                        [min]="minimumEmailWidthPx"
                        [max]="maximumEmailWidthPx"
                        unit="px"
                        [disabled]="!maxWidthEnabled"
                        [ngModel]="distributionMaxWidthPx"
                        (ngModelChange)="debouncedUpdateDistributionMaxWidth($event)"
                        (blur)="constrainDistributionMaxWidth()"
                        ariaDescribedBy="width_error"
                        useRemUnit="true"
                    ></agpr-number-input>
                    <agpr-form-message id="width_error" *ngIf="maxWidthEnabled && maxWidthOutOfRange">
                        <p>{{ 'Discover.targeting.distribution.rhp.maxWidth.outOfRangeErrorMessage' | localize }}</p>
                    </agpr-form-message>
                </agpr-panel>
                <agpr-distribution-global-customization [id]="'distribution_global'"></agpr-distribution-global-customization>
            </agpr-tab>
            <!-- Distribution Details -->
            <agpr-tab
                *ngIf="distribution.id"
                [id]="'distributionDetailsTab'"
                icon=" fa-file-lines"
                [showSpacer]="true"
                tooltip="Discover.distribution.details.distributionDetails"
            >
                <agpr-attribute-list
                    *ngIf="distributionAttributes?.length > 0"
                    class="agpr-distribution-details"
                    [attributes]="distributionAttributes"
                ></agpr-attribute-list>
            </agpr-tab>
        </agpr-right-sidebar>

        <agpr-right-sidebar
            *ngIf="editRecipientsTab?.selected"
            [showTabTitle]="false"
            class="agpr-recipientSection-sidebar"
            #rightSidebar
        >
            <ng-template #header>
                <label class="agpr-column-header agpr-recipientSection-header">{{'Discover.recipientEditor.labels.selectedRecipients' | localize }}</label>
            </ng-template>

            <ng-template #content>
                <agpr-scroll-panel class="agpr-right-column-scrollpanel">
                    <div *ngIf="recipientInformation.recipientGroups.length <= 1">
                        <div class="agpr-recipientSection-noContent">
                            <agpr-message
                                [severity]="messageSeverityEnum.noContent"
                            >
                                <span> {{ 'Discover.recipientEditor.labels.noRecipientsSelected' | localize }} </span>
                            </agpr-message>
                        </div>
                    </div>
                    <div
                        *ngFor="let recipientGroup of recipientInformation.recipientGroups"
                    >
                        <agpr-panel
                            *ngIf="(recipientGroup.type !== recipientTypes.email) && (recipientGroup.type !== recipientTypes.individual)"
                            [header]="recipientGroup.label"
                            class="agpr-recipientSection-recipientPanel"
                        >
                            <ng-template #panelHeader>
                                <span class="agpr-recipientSection-recipientLabel">
                                    {{ recipientGroup.total | number }}
                                </span>
                            </ng-template>
                            <div class="agpr-recipientSection-recipientCardContainer">
                                <div
                                    *ngFor="let recipient of recipientGroup.recipients"
                                    class="agpr-recipientSection-recipientCard agpr-contextMenu-parent"
                                    tabindex="0"
                                    [attr.aria-label]="recipient.label"
                                >
                                    <div class="agpr-recipientSection-recipientCard-group">
                                        <span class="agpr-recipientSection-recipientCard-itemLabel">
                                            {{ recipient.label }}
                                        </span>
                                        <span>
                                            {{ recipient.count | number }}
                                        </span>
                                    </div>
                                    <span
                                        *ngIf="recipient.isLocked"
                                        class="fa-regular fa-duotone fa-lock agpr-recipientSection-recipientCard-lock"
                                    ></span>

                                    <div
                                        class="agpr-contextMenu top right"
                                    >
                                        <agpr-button
                                            [style]="buttonTypes.contextMenu"
                                            [icon]="'fa-regular fa-duotone fa-gear'"
                                            (click)="openRecipientViewer(recipient)"
                                            class="agpr-recipientSection-recipientCard-contextMenu-button"
                                            tooltip="Discover.recipientEditor.labels.viewList"
                                            tooltipPosition="top"
                                        ></agpr-button>
                                        <agpr-button
                                            [style]="buttonTypes.contextMenu"
                                            [icon]="'fa-regular fa-duotone fa-trash-can'"
                                            (click)="recipientEditorService.removeRecipientByTrashIcon(recipient)"
                                            class="agpr-recipientSection-recipientCard-contextMenu-button"
                                            tooltip="Discover.recipientEditor.labels.removeList"
                                            tooltipPosition="top"
                                        ></agpr-button>
                                        <agpr-button
                                            *ngIf="recipientGroup.type === recipientTypes.search && recipient.isLocked"
                                            [style]="buttonTypes.contextMenu"
                                            [icon]="'fa-regular fa-duotone fa-unlock'"
                                            (click)="unlockSearch([recipient.targetingSearchId])"
                                            class="agpr-recipientSection-recipientCard-contextMenu-button"
                                            tooltip="Discover.recipientEditor.labels.unlockSearch"
                                            tooltipPosition="top"
                                        ></agpr-button>
                                        <agpr-button
                                            *ngIf="recipientGroup.type === recipientTypes.search && !recipient.isLocked"
                                            [style]="buttonTypes.contextMenu"
                                            [icon]="'fa-regular fa-duotone fa-lock'"
                                            (click)="lockSearch([recipient.targetingSearchId])"
                                            class="agpr-recipientSection-recipientCard-contextMenu-button"
                                            tooltip="Discover.recipientEditor.labels.lockSearch"
                                            tooltipPosition="top"
                                        ></agpr-button>
                                    </div>
                                </div>
                            </div>

                            <agpr-message
                                *ngIf="recipientGroup.type === recipientTypes.search && !isSearchesLocked"
                                id="distribution_lockSavedSearch_infoBanner"
                                class="agpr-distribution-infoBanner"
                                [severity]="messageSeverityEnum.info"
                            >
                                <span> {{ 'Discover.recipientEditor.banner.lockSearches' | localize }} </span>
                                <agpr-button
                                    class="agpr-distribution-link"
                                    [style]="buttonTypes.link"
                                    (click)="lockAllSearches()"
                                    label="Discover.recipientEditor.lockSearches"
                                ></agpr-button>
                            </agpr-message>

                            <agpr-message
                                *ngIf="recipientGroup.type === recipientTypes.search && isSearchesLocked"
                                id="distribution_unlockSavedSearch_infoBanner"
                                class="agpr-distribution-infoBanner"
                                [severity]="messageSeverityEnum.info"
                                [bottomMargin]="false"
                            >
                                <span> {{ 'Discover.recipientEditor.banner.unlockSearches' | localize }} </span>
                                <agpr-button
                                    class="agpr-distribution-link"
                                    [style]="buttonTypes.link"
                                    (click)="unlockAllSearches()"
                                    label="Discover.recipientEditor.unlockSearches"
                                ></agpr-button>
                            </agpr-message>

                        </agpr-panel>
                    </div>

                    @if(individualRecipientGroup) {
                        <agpr-panel
                            [header]="individualRecipientGroup.label"
                            class="agpr-recipientSection-recipientPanel"
                        >
                            <div class="agpr-recipientSection-recipientCardContainer">
                                @if((individualRecipientGroup.recipients?.[0]?.contactCount > 0) && (removedIndividualGroup !== searchModeEnum.contact)) {
                                    <div
                                        class="agpr-recipientSection-recipientCard agpr-contextMenu-parent"
                                        tabindex="0"
                                        [attr.aria-label]="individualRecipientGroup.recipients?.[0].label"
                                    >
                                        <div class="agpr-recipientSection-recipientCard-group">
                                            <span class="agpr-recipientSection-recipientCard-itemLabel">
                                                {{ 'Discover.recipientEditor.labels.individualContacts' | localize }}
                                            </span>
                                            <span class="agpr-recipientSection-recipientCard-count">
                                                {{ individualRecipientGroup.recipients?.[0].contactCount | number }}
                                            </span>
                                        </div>

                                        <div
                                            class="agpr-contextMenu top right"
                                        >
                                            <agpr-button
                                                [style]="buttonTypes.contextMenu"
                                                [icon]="'fa-regular fa-duotone fa-gear'"
                                                (click)="viewIndividualRecipients(searchModeEnum.contact)"
                                                class="agpr-recipientSection-recipientCard-contextMenu-button"
                                                tooltip="Discover.recipientEditor.labels.viewList"
                                                tooltipPosition="top"
                                            ></agpr-button>
                                            <agpr-button
                                                [style]="buttonTypes.contextMenu"
                                                [icon]="'fa-regular fa-duotone fa-trash-can'"
                                                (click)="removeIndividualRecipients(searchModeEnum.contact)"
                                                class="agpr-recipientSection-recipientCard-contextMenu-button"
                                                tooltip="Discover.recipientEditor.labels.removeList"
                                                tooltipPosition="top"
                                            ></agpr-button>
                                        </div>
                                    </div>
                                }
                                @if((individualRecipientGroup.recipients?.[0]?.outletCount > 0) && (removedIndividualGroup !== searchModeEnum.outlet)) {
                                    <div
                                        class="agpr-recipientSection-recipientCard agpr-contextMenu-parent"
                                        tabindex="0"
                                        [attr.aria-label]="individualRecipientGroup.recipients?.[0].label"
                                    >
                                        <div class="agpr-recipientSection-recipientCard-group">
                                            <span class="agpr-recipientSection-recipientCard-itemLabel">
                                                {{ 'Discover.recipientEditor.labels.individualOutlets' | localize }}
                                            </span>
                                            <span class="agpr-recipientSection-recipientCard-count">
                                                {{ individualRecipientGroup.recipients?.[0].outletCount | number }}
                                            </span>
                                        </div>

                                        <div
                                            class="agpr-contextMenu top right"
                                        >
                                            <agpr-button
                                                [style]="buttonTypes.contextMenu"
                                                [icon]="'fa-regular fa-duotone fa-gear'"
                                                (click)="viewIndividualRecipients(searchModeEnum.outlet)"
                                                class="agpr-recipientSection-recipientCard-contextMenu-button"
                                                tooltip="Discover.recipientEditor.labels.viewList"
                                                tooltipPosition="top"
                                            ></agpr-button>
                                            <agpr-button
                                                [style]="buttonTypes.contextMenu"
                                                [icon]="'fa-regular fa-duotone fa-trash-can'"
                                                (click)="removeIndividualRecipients(searchModeEnum.outlet)"
                                                class="agpr-recipientSection-recipientCard-contextMenu-button"
                                                tooltip="Discover.recipientEditor.labels.removeList"
                                                tooltipPosition="top"
                                            ></agpr-button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </agpr-panel>
                    }

                    <agpr-panel
                        header="Discover.recipientEditor.labels.additionalRecipients"
                        tooltip="Discover.recipientEditor.labels.addtionalRecipientInfo"
                        class="agpr-recipientSection-recipientPanel"
                    >
                        <agpr-email-chips
                            [id]="'additionalrecipients.chips'"
                            [(value)]="additionalRecipients"
                            (valueChange)="additionalRecipientsChanged()"
                            placeholder="Discover.targeting.distribution.editRecipient.additionalRecipients.placeholder"
                            [errorKey]="'Discover.targeting.distribution.editRecipient.invalidEmailMessage' | localize"
                            [showDuplicateErrorKey]="'Common.forms.email.duplicateEmail'"
                        ></agpr-email-chips>
                        <ng-template #panelHeader>
                            <span class="agpr-recipientSection-recipientLabel">
                                {{additionalRecipients.length}}
                            </span>
                        </ng-template>
                    </agpr-panel>
                </agpr-scroll-panel>
            </ng-template>

            <ng-template #footer>
                <agpr-quota-dropdown></agpr-quota-dropdown>
                <ng-container *ngTemplateOutlet="onlineBoost"></ng-container>
            </ng-template>
        </agpr-right-sidebar>

        @if (personalizeTab?.selected && hidePersonalizeSidebar) {
            <div class="emptySidebar">
                <ng-container *ngTemplateOutlet="onlineBoost"></ng-container>
            </div>
        }


        <agpr-rhp-contexts
            *ngIf="personalizeTab?.selected && !hidePersonalizeSidebar"
            id="distribution_rhpContexts"
            [(selectedTabIndex)]="personalizationRhpTabIndex"
            [overlayContainer]="overlayContainer"
            [hiddenNoContentMessage]="true"
        >
            <agpr-tab
                *ngIf="distribution.id"
                id="distributionDetailsTab"
                icon=" fa-file-lines"
                [showSpacer]="true"
                tooltip="Discover.distribution.details.distributionDetails"
            >
                <agpr-panel
                    *ngIf="distributionAttributes?.length > 0"
                    header="Discover.distribution.details.distributionDetails"
                >
                    <agpr-attribute-list
                        [attributes]="distributionAttributes"
                    ></agpr-attribute-list>
                </agpr-panel>
            </agpr-tab>
            <agpr-personalization-tab
                id="distributionPersonalizationTab"
                icon="fa-regular fa-duotone fa-pie-chart"
                tooltip="Discover.distribution.personalizationDetails"
                (changeStep)="currentStep = $event"
            ></agpr-personalization-tab>
            <ng-template #footer>
                <ng-container *ngTemplateOutlet="onlineBoost"></ng-container>
            </ng-template>
        </agpr-rhp-contexts>
    </aside>
</main>

<ng-template #onlineBoost>
    <div
        class="agpr-optimizeAndBoost"
        [ngClass]="boostBannerCollapsed ? 'agpr-optimizeAndBoost--collapsed' : 'agpr-optimizeAndBoost--expanded'"
    >
        @if (!boostBannerCollapsed) {
            @if (openAiPermission) {
                <div class="agpr-optimizeAndBoost-banner optimize">
                    <div class="agpr-optimizeAndBoost-label aeo">
                        <span
                            class="agpr-optimizeAndBoost-label-icon fa-kit-duotone fa-agpr-insights"
                        ></span>
                        @if (!distribution.id) {
                            <span>{{ 'Distribution.optimizeAndBoost.optimizer' | localize }}</span>
                        } @else {
                            <agpr-button
                                class="agpr-optimizeAndBoost-label-link"
                                label="Distribution.optimizeAndBoost.optimizer"
                                [style]="buttonTypes.link"
                                (click)="openAEODialog()"
                            ></agpr-button>
                        }
                        <span
                            class="agpr-infoIconStyle fa-regular fa-circle-info"
                            [agprTooltip]="'Distribution.optimizeAndBoost.optimizer.tooltip'"
                        ></span>
                    </div>

                    <span class="optimize-description">
                        @if (!distribution.id) {
                            {{ 'Distribution.optimizeAndBoost.optimizer.disabled' | localize }}
                        } @else if (!distributionDirty) {
                            {{ 'Distribution.optimizeAndBoost.optimizer.detail' | localize }}
                        } @else {
                            {{ 'Distribution.optimizeAndBoost.optimizer.saveDistributionGenerate' | localize }}
                        }
                    </span>
                    @if (recommendationsGenerated) {
                        <agpr-button
                            class="optimize-button"
                            [label]="'Distribution.optimizeAndBoost.optimizer.regenerateButton'"
                            [style]="buttonTypes.tertiary"
                            [disabled]="distributionDirty"
                            [tooltip]="distributionDirty ? 'Distribution.optimizeAndBoost.optimizer.saveDistributionGenerate' : ''"
                            (click)="openAEODialog(true)"
                        ></agpr-button>
                    }
                </div>
            }

            <div class="agpr-optimizeAndBoost-banner">
                <div class="agpr-optimizeAndBoost-label">
                    <span
                        class="agpr-optimizeAndBoost-label-icon fa-duotone fa-regular fa-bolt"
                    ></span>
                    <span class="agpr-optimizeAndBoost-label-text">{{ 'Distribution.onlineBoost' | localize }}</span>
                    <span
                        class="agpr-infoIconStyle fa-regular fa-circle-info"
                        [agprTooltip]="'Distribution.onlineBoost.dialog.message'"
                    ></span>
                </div>
                <agpr-social-switch
                    onText="Distribution.onlineBoost.active"
                    offText="Distribution.onlineBoost.inactive"
                    [(ngModel)]="distribution.onlineBoostApproved"
                    (ngModelChange)="onlineBoostChange()"
                >
                </agpr-social-switch>
            </div>
        }
        <div id="distribution_optimizeAndBoost_header" class="agpr-optimizeAndBoost-header">
            <div class="agpr-optimizeAndBoost-label">
                <span
                    class="agpr-optimizeAndBoost-label-icon fa-kit-duotone fa-agpr-ai-generic"
                ></span>
                <span class="agpr-optimizeAndBoost-label-text">{{ 'Distribution.optimizeAndBoost' | localize }}</span>
                @if (distribution.onlineBoostApproved) {
                    <span
                        class="agpr-optimizeAndBoost-activeIcon fa-solid fa-circle-bolt"
                        [agprTooltip]="'Distribution.onlineBoost.activeTooltip'"
                    ></span>
                }
            </div>
            <button
                id="distribution_optimizeAndBoost_collapseToggle"
                class="agpr-expandToggle fa-solid"
                [ngClass]="boostBannerCollapsed ? 'fa-angle-up' : 'fa-angle-down'"
                (click)="boostBannerCollapsed = !boostBannerCollapsed;"
            ></button>
        </div>

    </div>

</ng-template>
